import { TaskCancelledError } from "cockatiel";

import { isAbortError, isCausedByUserInput } from "../errors";

import { RobotoDashboardRevisionConflictException } from "./exceptions";

/**
 * Whether a failure is worth reporting to error monitoring: false for a metrics
 * dashboard's revision conflict, for canceled requests, and for an error that
 * says input a person gave caused it (`isCausedByUserInput`), such as a board
 * stage whose SQL the engine refuses.
 *
 * A revision conflict on a metrics dashboard is a save refused because someone
 * else saved first, and the editor lets the person resolve it.
 *
 * React Query filters its own cancellations before calling a reporter, but two
 * forms reach this check: an `AbortError` from `fetch`, and the
 * `TaskCancelledError` that `HttpClient`'s cockatiel retry policy raises when
 * the caller's signal aborts. That one is matched with `instanceof` because
 * cockatiel's `isTaskCancelledError` tests for `isBulkheadRejectedError`, a
 * property `TaskCancelledError` never sets.
 */
export function shouldReportError(error: unknown): boolean {
  return !(
    error instanceof RobotoDashboardRevisionConflictException ||
    isAbortError(error) ||
    isCausedByUserInput(error) ||
    error instanceof TaskCancelledError
  );
}
